<template>
  <div class="statistics-all">
    <div class="fix-style">
      <ol>
        <li>
          <router-link to="/my/Statistics" replace>
            <div>
              <span>网络投票</span>
            </div>
          </router-link>
        </li>
        <li>
          <router-link to="/my/StatisticsD" replace>
            <div>
              <span>满意度调查</span>
            </div>
          </router-link>
        </li>
      </ol>
      <div class="tips_text">点击各项标题即可查看详情</div>
    </div>
    <!--显示子路由内容部分-->
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'statisticsAll'
  }
</script>

<style lang="scss" scoped>
  .statistics-all {
    width: 100%;
    padding-top: 40px;
    /*border-bottom: 1px solid #d7d7d7;*/
    .fix-style{
      width: 100%;
      height: 80px;
      right: 0;
      left: 0;
      position: fixed;
      z-index: 666;
      background: #fff;
      border-bottom: 1px solid #d7d7d7;
      ol {
        width: 60%;
        list-style: none;
        margin-left: 20%;
        margin-top: 10px;
        li {
          width: 47%;
          float: left;
          height: 30px;
          text-align: center;
          margin-left: 2px;
          border: 1px solid #d7d7d7;
          a {
            width: 100%;
            color: #000000;
            font-size: 15px;
            font-weight: bolder;
            text-align: center;
            text-decoration: none;
            div {
              height: 30px;
              span {
                line-height: 30px;
              }
            }
          }
          a.active {
            color: #fff;
            font-size: 15px;
            font-weight: bolder;
            text-align: center;
            div {
              background-color: #00c96c;
            }
          }
        }
        li:first-child {
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;
        }
        li:last-child {
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
        }
        li:first-child a.active{
          div{
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
          }
        }
        li:last-child a.active{
          div{
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
          }
        }
      }
      .tips_text{
        width: 100%;
        display: inline-flex;
        justify-content: center;
        padding-top: 10px;
        font-size: 14px;
        color: red;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/my/statisticsAll.vue